
import React, {
    useEffect,
    useState
} from "react";

import axios from "axios";

import {
    useNavigate,
    useParams
} from "react-router-dom";

import {
    useSelector
} from "react-redux";

import {
    toast
} from "react-toastify";

import config from "../../config";

import Progressbar from "./Progressbar";

const API_SERVER = config.API_BASE_URL;

function RefurbishmentDetail() {

    const navigate = useNavigate();
const params = useParams();

const encryptedRepoId =
  params.repoId || params.id;

const repoId = encryptedRepoId
  ? atob(encryptedRepoId)
  : "";
    
const [repoCurrentStep, setRepoCurrentStep] =
    useState("Pending");

    const userData = useSelector(
        (state) => state.userInfo
    );

    const role = (
        userData?.roleIdWithName?.[0]
            ?.role_name || ""
    ).toLowerCase();

    // ==========================================
    // STATES
    // ==========================================

    const [loading, setLoading] =
        useState(false);

    // --- PRELOADER: tracks ANY POST request in-flight state ---
    const [postLoading, setPostLoading] = useState(false);

    const [repoData, setRepoData] =
        useState(null);

    const [formData, setFormData] =
        useState({

            estimated_cost: "",

            vendor_name: "",

            refurbishment_notes: ""

        });

    // ==========================================
    // GET REPO DETAILS
    // ==========================================

    useEffect(() => {

        fetchRepoDetails();
        fetchRepoProgress();
        fetchRefurbishmentData();
    }, []);

    const fetchRepoDetails =
        async () => {

            try {

                const response =
                    await axios.get(

                        `${API_SERVER}getVehicleRepoById/${repoId}`

                    );

                if (response.data.status) {

                    setRepoData(
                        response.data.data
                    );
                }

            } catch (error) {

                console.log(error);

                toast.error(
                    "Failed to load repo details"
                );
            }
        };

        const fetchRepoProgress = async () => {

    try {

        const res = await fetch(

            `${API_SERVER}get-repo-progress-flow?repo_id=${repoId}`

        );

        const result = await res.json();

        if (result.status) {

            setRepoCurrentStep(
                result.current_step
            );

        }

    } catch (error) {

        console.log(error);

    }

};

const fetchRefurbishmentData =
    async () => {

        try {

            const response =
                await axios.get(

                    `${API_SERVER}get-refurbishment-details/${repoId}`

                );

            console.table(response.data);

            if (
                response.data.status &&
                response.data.data
            ) {

                console.table(response.data.data);

                setFormData({

                    estimated_cost:
                        response.data.data.estimated_cost || "",

                    vendor_name:
                        response.data.data.vendor_name || "",

                    refurbishment_notes:
                        response.data.data.refurbishment_notes || ""

                });

            }

        } catch (error) {

            console.log(error);

        }

    };

    const handleChange = (e) => {

        setFormData({

            ...formData,

            [e.target.name]:
                e.target.value

        });
    };


    const handleSubmitToRH =
        async () => {

            if (
                !formData.estimated_cost ||
                !formData.vendor_name ||
                !formData.refurbishment_notes
            ) {

                toast.error(
                    "Please fill all mandatory fields"
                );

                return;
            }

            try {

                // --- PRELOADER: show overlay before POST request ---
                setPostLoading(true);
                setLoading(true);

                const payload = {

                    repo_id: repoId,

                    estimated_cost:
                        formData.estimated_cost,

                    vendor_name:
                        formData.vendor_name,

                    refurbishment_notes:
                        formData.refurbishment_notes,

                    created_by:
                        userData?.id
                };

                const response =
                    await axios.post(

                        `${API_SERVER}submitRefurbishment`,

                        payload
                    );

                if (response.data.status) {

                    toast.success(
                        "Sent To Regional Head"
                    );

                    navigate(
                        "/dashboard/view-repo-list"
                    );

                } else {

                    toast.error(
                        response.data.message
                    );
                }

            } catch (error) {

                console.log(error);

                toast.error(
                    "Something went wrong"
                );

            } finally {

                setLoading(false);

                // --- PRELOADER: hide overlay after POST finishes ---
                setPostLoading(false);
            }
        };

    // ==========================================
    // FORWARD TO CREDIT HEAD
    // ==========================================

    const handleForwardToCH =
        async () => {

            // --- PRELOADER: show overlay before POST request ---
            setPostLoading(true);

            try {

                const response =
                    await axios.post(

                        `${API_SERVER}forwardRefurbishmentToCH`,

                        {

                            repo_id: repoId,

                            updated_by:
                                userData?.id

                        }
                    );

                if (response.data.status) {

                    toast.success(
                        "Forwarded To Credit Head"
                    );

                    navigate(
                        "/dashboard/view-repo-list"
                    );

                } else {

                    toast.error(
                        response.data.message
                    );
                }

            } catch (error) {

                console.log(error);

                toast.error(
                    "Something went wrong"
                );

            } finally {

                // --- PRELOADER: hide overlay after POST finishes ---
                setPostLoading(false);

            }
        };

    // ==========================================
    // APPROVE
    // ==========================================

    const handleApprove =
        async () => {

            // --- PRELOADER: show overlay before POST request ---
            setPostLoading(true);

            try {

                const response =
                    await axios.post(

                        `${API_SERVER}approveRefurbishment`,

                        {

                            repo_id: repoId,

                            updated_by:
                                userData?.id

                        }
                    );

                if (response.data.status) {

                    toast.success(
                        "Refurbishment Approved"
                    );

                    navigate(
                        `/dashboard/final-submission/${btoa(repoId)}`
                    );

                } else {

                    toast.error(
                        response.data.message
                    );
                }

            } catch (error) {

                console.log(error);

                toast.error(
                    "Something went wrong"
                );

            } finally {

                // --- PRELOADER: hide overlay after POST finishes ---
                setPostLoading(false);

            }
        };

    // ==========================================
    // REJECT
    // ==========================================

    const handleReject =
        async () => {

            // --- PRELOADER: show overlay before POST request ---
            setPostLoading(true);

            try {

                const response =
                    await axios.post(

                        `${API_SERVER}rejectRefurbishment`,

                        {

                            repo_id: repoId,

                            updated_by:
                                userData?.id

                        }
                    );

                if (response.data.status) {

                    toast.success(
                        "Refurbishment Rejected"
                    );

                    navigate(
                        "/dashboard/view-repo-list"
                    );

                } else {

                    toast.error(
                        response.data.message
                    );
                }

            } catch (error) {

                console.log(error);

                toast.error(
                    "Something went wrong"
                );

            } finally {

                // --- PRELOADER: hide overlay after POST finishes ---
                setPostLoading(false);

            }
        };

    return (

        <div className="container-fluid py-3">

            {/* --- PRELOADER OVERLAY: shown during any POST request --- */}
            {postLoading && (
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  background: 'rgba(255,255,255,0.85)',
                  zIndex: 9999,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backdropFilter: 'blur(3px)'
                }}
              >
                <div
                  style={{
                    width: '56px',
                    height: '56px',
                    border: '5px solid #e0e0e0',
                    borderTop: '5px solid #1976d2',
                    borderRadius: '50%',
                    animation: 'spin 0.8s linear infinite'
                  }}
                />
                <p style={{ marginTop: '18px', fontWeight: 600, color: '#1976d2', fontSize: '15px' }}>
                  Processing, please wait...
                </p>
                {[1,2,3].map(i => (
                  <div
                    key={i}
                    style={{
                      width: '320px',
                      height: '14px',
                      borderRadius: '6px',
                      marginTop: '10px',
                      background: 'linear-gradient(90deg,#e0e0e0 25%,#f5f5f5 50%,#e0e0e0 75%)',
                      backgroundSize: '400% 100%',
                      animation: 'shimmer 1.4s infinite'
                    }}
                  />
                ))}
                <style>{`
                  @keyframes spin { to { transform: rotate(360deg); } }
                  @keyframes shimmer { 0%{background-position:100% 0} 100%{background-position:-100% 0} }
                `}</style>
              </div>
            )}
            {/* --- END PRELOADER OVERLAY --- */}


            <div className="card border-0 shadow-sm rounded-4">

                <div className="card-body p-4">

                   <div className="mb-3">

                            <h3 className="fw-bold mb-1">

                                Repair Details

                            </h3>

                            <p className="text-muted mb-0">

                                Vehicle Repair approval workflow

                            </p>

                        </div>

                        <div
                            style={{
                                width: "100%",
                                overflowX: "auto",
                                overflowY: "hidden",
                                paddingBottom: "8px",
                                marginBottom: "24px"
                            }}
                        >

                            <div
                                style={{
                                    minWidth: "1450px"
                                }}
                            >

                                <Progressbar
                                    currentStep={repoCurrentStep}
                                />

                            </div>

                    </div>


                    {
                        repoData && (

                            <div className="row mb-4">

                                <div className="col-md-3 mb-3">

                                    <label className="form-label fw-semibold">
                                        Agreement No
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control bg-light"
                                        value={
                                            repoData?.agreement_no || ""
                                        }
                                        disabled
                                    />

                                </div>

                                <div className="col-md-3 mb-3">

                                    <label className="form-label fw-semibold">
                                        Customer Name
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control bg-light"
                                        value={
                                            repoData?.customer_name || ""
                                        }
                                        disabled
                                    />

                                </div>

                                <div className="col-md-3 mb-3">

                                    <label className="form-label fw-semibold">
                                        Registration No
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control bg-light"
                                        value={
                                            repoData?.registration_number || ""
                                        }
                                        disabled
                                    />

                                </div>

                                <div className="col-md-3 mb-3">

                                    <label className="form-label fw-semibold">
                                        Vehicle Model
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control bg-light"
                                        value={
                                            repoData?.model || ""
                                        }
                                        disabled
                                    />

                                </div>

                            </div>
                        )
                    }

                    <div className="row">

                        <div className="col-md-4 mb-4">

                            <label className="form-label fw-semibold">
                                Estimated Cost *
                            </label>

                            <input
                                type="number"
                                className="form-control"
                                name="estimated_cost"
                                value={
                                    formData.estimated_cost
                                }
                                onChange={handleChange}
                                placeholder="Enter estimated cost"
                            />

                        </div>

                        <div className="col-md-4 mb-4">

                            <label className="form-label fw-semibold">
                                Vendor Name *
                            </label>

                            <input
                                type="text"
                                className="form-control"
                                name="vendor_name"
                                value={
                                    formData.vendor_name
                                }
                                onChange={handleChange}
                                placeholder="Enter vendor name"
                            />

                        </div>

                        <div className="col-md-12 mb-4">

                            <label className="form-label fw-semibold">
                                Refurbishment Notes *
                            </label>

                            <textarea
                                rows="5"
                                className="form-control"
                                name="refurbishment_notes"
                                value={
                                    formData.refurbishment_notes
                                }
                                onChange={handleChange}
                                placeholder="Enter refurbishment details..."
                            />

                        </div>

                    </div>

                    {/* ========================================== */}
                    {/* BUTTONS */}
                    {/* ========================================== */}

                    <div className="d-flex justify-content-end gap-2 mt-4">

                        <button
                            className="btn btn-secondary px-4"
                            onClick={() =>
                                navigate(-1)
                            }
                        >
                            Back
                        </button>

                        {/* USER */}

                        {
                            role === "manager" && (

                                // --- PRELOADER: button disabled while POST is in-flight ---
                                <button
                                    className="btn btn-primary px-4"
                                    onClick={
                                        handleSubmitToRH
                                    }
                                    disabled={loading || postLoading}
                                >
                                    {
                                        loading
                                            ? "Submitting..."
                                            : "Submit"
                                    }
                                </button>
                            )
                        }

                        {/* REGIONAL HEAD */}

                        {
                            role === "regional head" && (

                                <>

                                    {/* --- PRELOADER: buttons disabled while POST is in-flight --- */}
                                    <button
                                        className="btn btn-danger px-4"
                                        onClick={
                                            handleReject
                                        }
                                        disabled={postLoading}
                                        style={{ opacity: postLoading ? 0.7 : 1 }}
                                    >
                                        Reject
                                    </button>

                                    <button
                                        className="btn btn-warning px-4"
                                        onClick={
                                            handleForwardToCH
                                        }
                                        disabled={postLoading}
                                        style={{ opacity: postLoading ? 0.7 : 1 }}
                                    >
                                        Forward
                                    </button>

                                </>
                            )
                        }

                        {/* CREDIT HEAD */}

                        {
                            role === "credit head" && (

                                <>

                                    {/* --- PRELOADER: buttons disabled while POST is in-flight --- */}
                                    <button
                                        className="btn btn-danger px-4"
                                        onClick={
                                            handleReject
                                        }
                                        disabled={postLoading}
                                        style={{ opacity: postLoading ? 0.7 : 1 }}
                                    >
                                        Reject
                                    </button>

                                    <button
                                        className="btn btn-success px-4"
                                        onClick={
                                            handleApprove
                                        }
                                        disabled={postLoading}
                                        style={{ opacity: postLoading ? 0.7 : 1 }}
                                    >
                                        Approve
                                    </button>

                                </>
                            )
                        }

                    </div>

                </div>

            </div>

        </div>
    );
}

export default RefurbishmentDetail;